import React from 'react';
import classnames from 'classnames';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { useScrollReveal } from '@/hooks/useScrollReveal.hook';
import { programContent } from '@/data/staticProgramData';
import ProgramRegistrationForm from '../ProgramRegistrationForm';
import './ProgramRegistrationSection.scss';

const ProgramRegistrationSection = ({ selectedInterest = 'company' }) => {
  const { title } = programContent.registrationSection;
  const { wrapperRef, isVisible } = useScrollReveal({ repeat: true });

  return (
    <section className="program-section program-section--registration" id="registro">
      <FlexContainer
        className={classnames('program-registration-section flex-column', {
          'program-scroll-reveal--visible': isVisible,
        })}
        wrapperRef={wrapperRef}
      >
        <h2 className="program-section-title">{title}</h2>
        <ProgramRegistrationForm
          variant="section"
          enableScrollReveal={false}
          selectedInterest={selectedInterest}
        />
      </FlexContainer>
    </section>
  );
};

export default ProgramRegistrationSection;
